import { FC } from "react";
import { Trans } from "react-i18next";
import { LogoFull } from "assets/svg";
import { useAppSelector } from "store/hooks";
import { userMetadataSelector } from "store/selectors";

import { Emphasized } from "uikit";

import { IProps } from "./types";
import useCBACards from "./useCBACards";
import {
  CBACardFooter,
  CBACardMainContent,
  CBACFDisclaimer,
  CBACFPPSubitle,
  CBACFPPText,
  CBACFPPTitle,
  CBACFPromoPoint,
  CBACFPromoPointsContainer,
  CBCMAAmountText,
  CBCMAAmountTextSmall,
  CBCMAText,
  CBCMATextContainer,
  CBCMATextEmphasized,
  CBCMATitle,
  CBCMATop,
  CBCMATopLogo,
  CBCMATopTitle,
  CompanyEmphasized,
  ContainerPba,
} from "./styles";

const CBACard3: FC<IProps> = (props) => {
  const { className } = props;

  const commonTranslationPrefix = `components.company_bank_account_promo_cards.shared`;
  const translationPrefix = `components.company_bank_account_promo_cards.card3`;

  const currentUser = useAppSelector(userMetadataSelector);

  const { basePbaConfig } = useCBACards(props);

  const renderLargeCompanyBankAccountCardContent = () => {
    return (
      <CBACardMainContent>
        <CBCMATop>
          <CBCMATopLogo>
            <LogoFull />
          </CBCMATopLogo>
          <CBCMATopTitle>
            <Trans i18nKey={`${commonTranslationPrefix}.title_common_pba`} />
          </CBCMATopTitle>
        </CBCMATop>
        <CBCMATitle>
          <Trans i18nKey={`${translationPrefix}.title`} />
        </CBCMATitle>
        <CBCMATextContainer>
          <Trans
            i18nKey={`${translationPrefix}.description`}
            values={{
              firstName: currentUser?.personalInfo?.firstName || "",
            }}
            components={{
              1: <CBCMATextEmphasized />,
              2: <CBCMAText />,
              3: <Emphasized />,
              4: <CBCMAAmountText />,
              5: <CBCMAAmountTextSmall />,
            }}
          />
        </CBCMATextContainer>
      </CBACardMainContent>
    );
  };

  const renderLargeCompanyBankAccountCardFooterContent = () => {
    return (
      <CBACardFooter>
        <CBACFPromoPointsContainer>
          <CBACFPromoPoint>
            <Trans
              i18nKey={`${commonTranslationPrefix}.promo_points.p1_alt`}
              components={{
                1: <CBACFPPTitle />,
                2: <CBACFPPSubitle />,
                3: <CBACFPPText />,
              }}
            />
          </CBACFPromoPoint>

          <CBACFPromoPoint>
            <Trans
              i18nKey={`${commonTranslationPrefix}.promo_points.p3_alt`}
              components={{
                1: <CBACFPPTitle />,
                2: <CBACFPPSubitle />,
                3: <CBACFPPText />,
              }}
            />
          </CBACFPromoPoint>
        </CBACFPromoPointsContainer>
        <CBACFDisclaimer>
          <Trans i18nKey={`${translationPrefix}.disclaimer`} />
        </CBACFDisclaimer>
      </CBACardFooter>
    );
  };

  const cardConfig = {
    title: (
      <Trans
        i18nKey={`${translationPrefix}.title`}
        components={{
          1: <CompanyEmphasized />,
        }}
      />
    ),
    description: (
      <Trans
        i18nKey={`${translationPrefix}.description`}
        components={{
          1: <CompanyEmphasized />,
        }}
      />
    ),
    largeContent: renderLargeCompanyBankAccountCardContent(),
    largeFooterContent: renderLargeCompanyBankAccountCardFooterContent(),
  };

  const config: IProps = {
    ...basePbaConfig,
    ...cardConfig,
    ...props,
  };

  return <ContainerPba className={className} {...config} />;
};

export default CBACard3;
